import { API_ENDPOINTS } from '../config/constants';
import { apiFetch, publicApiFetch } from './common';
import type { UserProfile } from '../../types';

// Auth API
export const AuthAPI = {
  async login(
    email: string,
    password: string,
  ): Promise<{ access_token: string; refresh_token: string }> {
    return publicApiFetch<{ access_token: string; refresh_token: string }>(
      API_ENDPOINTS.AUTH.LOGIN,
      {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      },
    );
  },
  async getProfile(): Promise<UserProfile> {
    return apiFetch<UserProfile>(API_ENDPOINTS.AUTH.PROFILE);
  },
  async requestPasswordReset(email: string): Promise<void> {
    await publicApiFetch(API_ENDPOINTS.AUTH.REQUEST_PASSWORD_RESET, {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  },
  async resetPassword(token: string, password: string): Promise<void> {
    await publicApiFetch(API_ENDPOINTS.AUTH.RESET_PASSWORD, {
      method: 'POST',
      body: JSON.stringify({ token, password }),
    });
  },
  async resetPasswordWithJWT(
    accessToken: string,
    refreshToken: string,
    password: string,
  ): Promise<void> {
    await publicApiFetch(API_ENDPOINTS.AUTH.RESET_PASSWORD_WITH_JWT, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'X-Refresh-Token': refreshToken,
      },
      body: JSON.stringify({ password }),
    });
  },
};
